type StatusBadgeProps = {
  status: "追踪中" | "已反转" | "已回应";
  size?: "sm" | "md";
};

const STYLES: Record<string, { wrap: string; dot: string }> = {
  追踪中: {
    wrap: "bg-primary-100 text-primary-800 border-primary-200",
    dot: "bg-primary-500 animate-track-pulse",
  },
  已反转: {
    wrap: "bg-accent-100 text-accent-900 border-accent-300",
    dot: "bg-accent-500",
  },
  已回应: {
    wrap: "bg-secondary-100 text-secondary-900 border-secondary-200",
    dot: "bg-secondary-500",
  },
};

export default function StatusBadge({ status, size = "sm" }: StatusBadgeProps) {
  const style = STYLES[status] ?? STYLES["追踪中"];
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border font-label font-medium ${style.wrap} ${
        size === "sm" ? "px-2.5 py-0.5 text-xs" : "px-3 py-1 text-sm"
      }`}
    >
      <span className={`block h-1.5 w-1.5 rounded-full ${style.dot}`} />
      {status}
    </span>
  );
}